@if (modalController) {
<div class="super-back-button-modal" (click)="handleBack()">
  <ion-icon [name]="displayIcon" [color]="color"></ion-icon>
</div>
} @else {
<div class="super-back-button-wrapper" sxCenterize="row" (click)="handleBack()">
  <ion-icon [name]="displayIcon" [color]="color"></ion-icon>
  @if (text) {
  <span class="back-text">{{ text }}</span>
  }
</div>
}